export default __webpack_public_path__ + "static/media/5-1.4857eb5b.jpg";